import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import BelvoirExplorer from './BelvoirExplorer';

/**
 * Full-screen garden explorer. Site chrome (nav, banners, cookies) is hidden
 * on /explore. Uses the updated Blender export (belvoir-gardens.glb).
 */
export default function CastleMapPage() {
  useEffect(() => {
    const body = document.body;
    const html = document.documentElement;
    const prevBody = body.style.overflow;
    const prevHtml = html.style.overflow;
    body.style.overflow = 'hidden';
    html.style.overflow = 'hidden';
    return () => {
      body.style.overflow = prevBody;
      html.style.overflow = prevHtml;
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>A little world to explore — Coming soon | Belvoir Castle</title>
        <meta
          name="description"
          content="A little world to explore is coming soon. An illustrated garden map of Belvoir Castle and the grounds."
        />
        <meta name="robots" content="noindex" />
      </Helmet>
      <BelvoirExplorer assetBase="" embedded={false} />
    </>
  );
}
